'use strict';

var BaseModel = require('./Base');
var Model;

/**
 * @name module:models.Address
 * @augments module:models.BaseModel
 * @constructor
 *
 * @property {string} line1 - The street name, building and apt number
 * @property {string} city - The city's name
 * @property {string} state - The state code
 * @property {string} postcode - The postal code
 * @property {string} contactPhone - A contact phone
 */
module.exports = Model = BaseModel.extend('Address',
/** @lends module:models.Address */
{
    /**
     * Addresses are not softDeletable
     *
     * @type {boolean}
     * @default
     * @protected
     */
    softDelete: false,

    defaults: {
        line1: '',
        city: '',
        state: '',
        postcode: '',
        contactPhone: ''
    },

    constraints: {
        line1: {presence: {message: '^Street Address is required'}},
        city: {presence: {message: '^City is required'}},
        state: {presence: {message: '^State is required'}},
        postcode: {
            presence: {message: '^Post Code is required'},
            format: {
                pattern: /\d{5}/,
                message: '^Invalid post code format'
            }
        },
        contactPhone: {presence: {message: '^Contact Phone is required'}}
    },

    /**
     * Return the state name from the code we have stored in
     * the instance
     *
     * @instance
     * @returns {string} The state name as a string. Empty string
     *  if code is invalid
     */
    getStateName: function() {
        return Model.getStateName(this.get('state'));
    },

    /**
     * Returns the model's attributes as JSON. We override
     * {@link module:models.BaseModel#toJSON} so we can return the actual
     * state name if needed.
     *
     * @instance
     * @param {object} options - A backbone-style options object
     * @returns {object} The attributes as JSON
     */
    toJSON: function(options) {
        var self = this;
        var r = BaseModel.prototype.toJSON.apply(self, arguments);

        options = _.defaults(options || {}, {
            asAdditionalInformation: false
        });

        if (options.asAdditionalInformation === true) {
            r.state = self.getStateName();
        }

        return r;
    }
}, {
    /**
     * The states
     *
     * @memberof module:models.Address
     * @static
     * @public
     */
    states: [
        {code: '01', name: 'Johor'},
        {code: '02', name: 'Kedah'},
        {code: '03', name: 'Kelantan'},
        {code: '14', name: 'Kuala Lumpur'},
        {code: '15', name: 'Labuan'},
        {code: '04', name: 'Malacca'},
        {code: '05', name: 'Negeri Sembilan'},
        {code: '06', name: 'Pahang'},
        {code: '07', name: 'Penang'},
        {code: '08', name: 'Perak'},
        {code: '09', name: 'Perlis'},
        {code: '16', name: 'Putrajaya'},
        {code: '12', name: 'Sabah'},
        {code: '13', name: 'Sarawak'},
        {code: '10', name: 'Selangor'},
        {code: '11', name: 'Terengganu'}
    ],

    /**
     * Get the state name corresponding to a code
     *
     * @memberof module:models.Address
     * @static
     * @param {string} code - The code to lookup
     * @returns {string} The state name. Empty string if no
     *  state name found.
     */
    getStateName: function(code) {
        var state = _.find(Model.states, state => state.code === code);
        return state ? state.name : '';
    }
});



// WEBPACK FOOTER //
// ./app/models/Address.js